import { ActivitiesServiceInterface } from 'domain/services';
import {
  DeleteActivityUseCaseInterface,
  DeleteActivityValidationUseCaseInterface,
  GetActivitiesInProgressCountGroupedByOrganizationUseCaseInterface,
  GetActivityByIdUseCaseInterface,
} from 'domain/usecases';

export class ActivitiesService implements ActivitiesServiceInterface {
  constructor(
    private readonly _getActivitiesInProgressCountGroupedByOrganization: GetActivitiesInProgressCountGroupedByOrganizationUseCaseInterface,
    private readonly _getActivityById: GetActivityByIdUseCaseInterface,
    private readonly _deleteActivity: DeleteActivityUseCaseInterface,
    private readonly _deleteActivityValidation: DeleteActivityValidationUseCaseInterface,
  ) {}

  getActivitiesInProgressCountGroupedByOrganization(): Promise<GetActivitiesInProgressCountGroupedByOrganizationUseCaseInterface.Result> {
    return this._getActivitiesInProgressCountGroupedByOrganization.execute();
  }

  getActivityById(
    params: GetActivityByIdUseCaseInterface.Params,
  ): Promise<GetActivityByIdUseCaseInterface.Result> {
    return this._getActivityById.execute(params);
  }

  deleteActivity(
    params: DeleteActivityUseCaseInterface.Params,
  ): Promise<DeleteActivityUseCaseInterface.Result> {
    return this._deleteActivity.execute(params);
  }

  deleteActivityValidation(
    params: DeleteActivityValidationUseCaseInterface.Params,
  ): Promise<DeleteActivityValidationUseCaseInterface.Result> {
    return this._deleteActivityValidation.execute(params);
  }
}
